import { ActivityFilter, defaultAvailableActivities } from 'components/Blotters/Filter/ActivityFilter';
import { AdvancedFilterButton } from 'components/Blotters/Filter/AdvancedFilterButton';
import { BlotterTitleContainer, BlotterTitleLabel } from 'components/Blotters/Filter/blotter-title';
import { CurrencyFilter } from 'components/Blotters/Filter/CurrencyFilter';
import { DateFilter } from 'components/Blotters/Filter/DateFilter';
import { FullTextSearch } from 'components/Blotters/Filter/full-text-search';
import { DropdownWrapper, SpDropdownItem } from 'components/shared/Dropdown';
import { TinySpinner } from 'components/shared/TinySpinner/TinySpinner';
import { FC } from 'react';
import { DropdownMenu, DropdownToggle } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { ExportCsv } from '../../Filter/ExportCsv';
import type { DispatchProps, OwnProps, StateProps } from './Filter.connect';
import { connectFilterComponent } from './Filter.connect';
import { availablePlatformFilters, getPlatformTranslationKey } from './Filter.helper';

export type FilterProps = OwnProps & StateProps & DispatchProps;

export const Filter: FC<FilterProps> = props => {
  const { fetchCsv, requestParams } = props;

  return (
    <div className="secondary-market-blotter-filters align-items-center w-100">
      <div className="d-flex flex-row border-top bg-lvl1 flex-wrap flex-md-nowrap">
        <BlotterTitleContainer className="flex-grow-1">
          <BlotterTitleLabel>
            <FormattedMessage id="secondaryMarket.blotter.filter.title" />
          </BlotterTitleLabel>
          {props.isLoading && <TinySpinner className="ms-2" />}
        </BlotterTitleContainer>
        <ActivityFilter
          activities={defaultAvailableActivities}
          value={props.activityFilter}
          onSelect={props.onActivityFilterChanged}
        />
        <DropdownWrapper className="btn-group border-start border-opacity-40" openOnHover>
          <DropdownToggle
            variant="link"
            aria-haspopup="listbox"
            data-e2e="platform-filter"
            className="btn btn-flat-secondary btn-lg btn-icon-start dropdown-toggle pe-2"
          >
            <i className="icon">layers</i>
            <span className="d-none d-lg-inline">
              <FormattedMessage id={getPlatformTranslationKey(props.platformFilter)} />
            </span>
          </DropdownToggle>
          <DropdownMenu role="listbox">
            {availablePlatformFilters().map(({ value: platform }) => (
              <SpDropdownItem
                active={platform === props.platformFilter}
                key={platform}
                onClick={() => props.onPlatformFilterChanged(platform)}
              >
                <FormattedMessage id={getPlatformTranslationKey(platform)} />
              </SpDropdownItem>
            ))}
          </DropdownMenu>
        </DropdownWrapper>
        <DateFilter value={props.dateFilter} onChange={props.onDateFilterChanged} />
        <FullTextSearch
          value={props.quickSearchTerm}
          onChange={props.onQuickSearchTermChanged}
          placeholder="blotter.filter.secondaryMarketQuickSearch.placeholder"
        >
          <ExportCsv fetch={() => fetchCsv(requestParams)} className="d-inline-block" />
          <AdvancedFilterButton value={props.advancedFilters} onToggle={props.onAdvancedFilterToggled} />
        </FullTextSearch>
      </div>
      {props.advancedFilters && (
        <div className="d-flex border-top justify-content-end">
          <CurrencyFilter
            currencyFilter={props.currencyFilter}
            onCurrencyFilterChanged={props.onCurrencyFilterChanged}
          />
        </div>
      )}
    </div>
  );
};

export const ConnectedFilter = connectFilterComponent(Filter);
